import Vue from 'vue'
import myDrawer from './myDrawer/index.vue'
import myDialog from './myDialog/index.vue'
import myTableSearch from './myTableSearch/index.vue'
import myForm from './myForm/index.vue'
import myMapDrawer from './myMapDrawer/index.vue'
import myTree from './myTree/index.vue'
import mySubmitButton from './mySubmitButton/index.vue'
import myMapPopup from './myMapPopup/index.vue'
import myPageAdd from './myPageAdd/index.vue'
import myNnumberRoll from './myNnumberRoll/index.vue'
let obj = {
  myDialog,
  myDrawer,
  myTableSearch,
  myForm,//form表单
  myMapDrawer,
  myTree,//自定义树形
  mySubmitButton,//form提交按钮
  myMapPopup,//地图自定义弹窗
  myPageAdd,//页面新增
  myNnumberRoll,//数字滚动
}

for (const key in obj) {
  Vue.component(key,obj[key]);
}